import { z } from 'zod';
import { LIMITS } from '../registries/limits.ts';

export const Id = z.uuid();
export type Id = z.infer<typeof Id>;

export const IsoDateTime = z.iso.datetime({ offset: true });
export type IsoDateTime = z.infer<typeof IsoDateTime>;

/** Milliseconds since the Unix epoch, as measured by the server clock. */
export const EpochMs = z.number().int().nonnegative();

export const DurationMs = z.number().int().nonnegative();

export const DisplayName = z.string().trim().min(LIMITS.displayName.min).max(LIMITS.displayName.max);

export const Title = z.string().trim().min(LIMITS.title.min).max(LIMITS.title.max);

/** BCP 47 primary language subtag (ISO 639-1 where one exists, otherwise ISO 639-3), e.g. "pl". */
export const LanguageCode = z
  .string()
  .regex(/^[a-z]{2,3}$/)
  .describe('BCP 47 primary language subtag');

/** Opaque pagination cursor produced by the server. */
export const Cursor = z.string().min(1).max(200);

export const pageOf = <T extends z.ZodType>(item: T) =>
  z.object({
    items: z.array(item),
    /** Pass as `cursor` to load the next page; null when there is nothing more. */
    nextCursor: Cursor.nullable(),
  });

export const PageQuery = z.object({
  cursor: Cursor.optional(),
  limit: z.coerce
    .number()
    .int()
    .min(LIMITS.pageSize.min)
    .max(LIMITS.pageSize.max)
    .default(LIMITS.pageSize.default),
});
